import { Col, Row, Typography } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import React from 'react';
import { countryList } from '../../data/countryList';
import TabsView from '../Common/TabsVIew';
import CourseEnrolmentTable from '../courseEnrolment/CourseEnrolmentTable';
import InfoItem from './InfoItem';

const { Title } = Typography;

function findCountryName(id) {
  if(id){
    return countryList.find((data) => data.id === id).name;
  }
  return null;
}

function LearnerInfo({
  learner,
  enrolments,
  setSelectedRowKeys,
  setSelectedRows,
}) {
  const equipmentLabelMap = (value) => {
    if (value) {
      return equipmentValueMap(value);
    } else {
      return 'N.A.';
    }
  };

  const equipmentValueMap = (value) => {
    switch (value) {
      case 'mac':
        return 'Macbook';
      case 'windows':
        return 'Windows';
      case 'linux':
        return 'Linux';
      case 'fcp':
        return 'Final Cut Pro';
      case 'pp':
        return 'Premiere Pro';
      case 'dslr':
        return 'DSLR';
      case 'phone':
        return 'Phone Camera';
      case null:
        return null;
      case 'others':
        return 'Others';
      default:
        return null;
    }
  };

  const renderItems = (data) => {
    const items = data.map(({ label, value }, i) => (
      <InfoItem label={label} value={value} />
    ));

    return <>{items}</>;
  };

  const basicInfo = [
    { label: 'Learner Id', value: learner?.learnerId },
    {
      label: 'First Name',
      value: learner?.firstName,
    },
    {
      label: 'Last Name',
      value: learner?.lastName,
    },
    {
      label: 'Email',
      value: learner?.email,
    },
    {
      label: 'Business email',
      value: learner?.corporateEmailSameAsLoginEmail
        ? 'Same as Login Email'
        : learner?.corporateEmail,
    },
    {
      label: 'Phone Number',
      value: learner?.phoneNumber,
    },
    {
      label: 'WhatsApp Number',
      value: learner?.whatsAppNumberSameAsPhoneNumber
        ? 'Same as Phone Number'
        : learner?.whatsAppNumber,
    },
    {
      label: 'Profile Image',
      value: learner?.profileImage,
    },
    {
      label: 'Description',
      value: learner?.description,
    },
    {
      label: 'Is Active',
      value: learner?.isActive.toString(),
    },
  ];

  const addressInfo = [
    {
      label: 'Country',
      value: findCountryName(learner?.countryId),
    },
    {
      label: 'City',
      value: learner?.address?.city,
    },
    {
      label: 'Postal Code',
      value: learner?.address?.postalCode,
    },
    {
      label: 'Address',
      value: learner?.address?.address,
    },
    {
      label: 'Additional address',
      value: learner?.address?.additionalAddress,
    },
  ];

  const equipmentInfo = [
    {
      label: 'Laptop type',
      value: equipmentLabelMap(learner?.extraInfo?.laptop?.type),
    },
    {
      label: 'Editing Software',
      value: equipmentLabelMap(learner?.extraInfo?.editingSoftware?.type),
    },
    {
      label: 'Camera type',
      value: equipmentLabelMap(learner?.extraInfo?.camera?.type),
    },
  ];

  const firstNameInitial =
    learner && learner?.firstName ? learner?.firstName.substring(0, 1) : '';
  const tabs = [
    {
      render: () => (
        <Row justify="space-between">
          <Col span={8}>{renderItems(basicInfo)}</Col>
          <Col span={8}>
            {basicInfo.profileImage ? (
              <Avatar
                shape="square"
                alt="profile"
                src={basicInfo.profileImage}
                size={140}
              />
            ) : (
              <Avatar
                shape="square"
                className="avatar-fallback"
                alt="profile"
                size={140}
              >
                {firstNameInitial}
              </Avatar>
            )}
          </Col>
        </Row>
      ),
      tab: 'Basic Info',
    },
    {
      render: () => renderItems(addressInfo),
      tab: 'Address',
    },
    {
      render: () => renderItems(equipmentInfo),
      tab: 'Equipment Info',
    },
    {
      render: () => {
        const items = learner?.socialMedia.map(({ type, link }) => ({
          label: type,
          value: link,
        }));

        items.unshift({ label: 'Content Style', value: learner?.contentStyle });

        return renderItems(items);
      },
      tab: 'Social Media',
    },
  ];

  return (
    <div>
      <section>
        <TabsView data={tabs} />
      </section>
      <section>
        <Title style={{ fontSize: '16px' }}>Enrolment</Title>
        <CourseEnrolmentTable
          data={enrolments}
          setSelectedRowKeys={setSelectedRowKeys}
          setSelectedRows={setSelectedRows}
        />
      </section>
    </div>
  );
}

export default LearnerInfo;
